'use client';
import React from 'react';
import { withOptionalId } from '@lib/withOptionalId';
import { DataTable, Heading, type ColumnDef, type SortKey } from '@ui';
import { Section, Container } from '@layout';
import MarkupSnippet, { markupCopyLabels } from '../markup-snippet/MarkupSnippet';

interface DataTableDemoProps {
  sectionID?: string;
  classes?: string;
  containerId?: string;
  containerClasses?: string;
  isSpanish?: boolean;
}

const DataTableDemo: React.FC<DataTableDemoProps> = ({
  isSpanish = false,
  sectionID = '',
  classes = '',
  containerId,
  containerClasses,
}) => {
  const t = (en: string, es: string) => (isSpanish ? es : en);

  const thTitles = isSpanish
    ? ([
        { title: 'ID', key: 'id' as SortKey, type: 'number' },
        { title: 'Fase', key: 'phase' as SortKey },
        { title: 'Versión', key: 'version' as SortKey },
        { title: 'Estado', key: 'status' as SortKey },
        { title: 'Tarea', key: 'task' as SortKey, type: 'number' },
      ] satisfies ColumnDef[])
    : undefined;

  const phasePlaceholder = isSpanish ? 'Filtrar por Fase' : undefined;
  const statusPlaceholder = isSpanish ? 'Filtrar por Estado' : undefined;

  return (
    <Section {...withOptionalId(sectionID)} className={classes}>
      <Container containerId={containerId} containerClasses={containerClasses}>
        <Heading as="h3">{t('Data Table', 'Tabla de datos')}</Heading>
        <p className='sub full'>
          {t(
            'Sortable columns, sticky header, and client-side pagination.',
            'Columnas ordenables, encabezado fijo y paginación en el cliente.'
          )}
        </p>

        <DataTable
          tableId='data-table-demo'
          tableHelpId='data-table-demo-help'
          thTitles={thTitles}
          phasePlaceholder={phasePlaceholder}
          statusPlaceholder={statusPlaceholder}
        />
      <MarkupSnippet
          {...markupCopyLabels(isSpanish)}
          code={`<div class="table-container">
  <table>
    <thead>
      <tr><th class="th-sort">Name</th><th>Status</th></tr>
    </thead>
    <tbody>
      <tr><td>Alpha</td><td>Open</td></tr>
    </tbody>
  </table>
</div>`}
        />
      </Container>
    </Section>
  );
};

export default DataTableDemo;
